import { createFileRoute } from '@tanstack/react-router'

import { PlayerProfileRouteKernel } from '~/features/football-entities/route-modules'
import { playerProfileRouteModule } from '~/features/football-entities/route-options'

export const Route = createFileRoute('/$locale/_public/players/$playerId')({
  ...playerProfileRouteModule,
  component: PlayerProfileRoute,
})

function PlayerProfileRoute() {
  return <PlayerProfileRouteKernel route={Route} />
}
